var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.7974C20 5.24084 15.5229 0.736328 10 0.736328C4.47715 0.736328 0 5.24084 0 10.7974C0 15.8191 3.65684 19.9815 8.4375 20.7363V13.7057H5.89844V10.7974H8.4375V8.58085C8.4375 6.05929 9.9305 4.66645 12.2146 4.66645C13.3088 4.66645 14.4531 4.86296 14.4531 4.86296V7.33894H13.1922C11.95 7.33894 11.5625 8.11455 11.5625 8.91023V10.7974H14.3359L13.8926 13.7057H11.5625V20.7363C16.3432 19.9815 20 15.8193 20 10.7974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9859b328e44a20e545c62c3639470ad3.svg";
export { ForwardRef as ReactComponent };